export const formatDate = (input?: number | string | Date) => {
  if (!input) return;

  const date = new Date(input);

  const formatter = new Intl.DateTimeFormat('pl-PL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  return formatter.format(date);
};
